import React from "react";
import { useAppContext } from "store/context";
import Devices from "./components/Devices";

const DeviceContainer = ({ devices }) => {
  const { firebase } = useAppContext();

  const onChange = async (device_id, value) => {
    await firebase.firestore().collection("devices").doc(device_id).update({
      device_nickname: value,
    });
  };

  return <Devices devices={devices} handleChange={onChange} />;
};

export default DeviceContainer;
